import { OrderCourierEnum } from "@saleor/motherOrders/utils/enums";
import _ from "lodash";
import moment from "moment-timezone";

export const disableSubmitButton = (
  isInHouse,
  selectedInHouseRider,
  thirdPartyRider,
  loading,
  // riderData,
  // transactionTime,
  InHouseinitialForm,
  isOrderCompleted: boolean,
  isOrderCancelled: boolean
) => {
  if (loading) {
    return true;
  } else {
    if (isInHouse) {
      if (
        !selectedInHouseRider &&
        !InHouseinitialForm?.riderId &&
        (!isOrderCompleted || !isOrderCancelled)
        //   ||(transactionTime.timeDispatched === "" &&
        // transactionTime.timeDelivered === "")
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        _.isEmpty(thirdPartyRider) ||
        thirdPartyRider?.courier === "" ||
        thirdPartyRider?.courier === null ||
        thirdPartyRider?.courier === undefined ||
        thirdPartyRider?.courier === OrderCourierEnum.O2GO ||
        isOrderCompleted
        //  || (transactionTime.timeDispatched === "" &&
        //   transactionTime.timeDelivered === "")
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};

export const handleTimeTransaction = data => {
  const {
    timeDelivered,
    timeDispatched,
    orderCreated,
    dateDispatched = null,
    dateDelivered = null
  } = data;

  const dateDispatchedFormatted = moment(dateDispatched || orderCreated).format(
    "YYYY-M-D"
  );
  const dateDeliveredFormatted = moment(dateDelivered || orderCreated).format(
    "YYYY-M-D"
  );

  const mergeDateTimeDispatched1 = new Date(
    dateDispatchedFormatted + " " + timeDispatched
  );
  const newTimeDispatched = moment(
    mergeDateTimeDispatched1.toString()
  ).format();

  const mergeDateTimeDelivered = new Date(
    dateDeliveredFormatted + " " + timeDelivered
  );
  const newTimeDelivered = moment(mergeDateTimeDelivered.toString()).format();

  return {
    timeDelivered:
      newTimeDelivered === "Invalid date" || timeDelivered === ""
        ? null
        : newTimeDelivered,
    timeDispatched:
      newTimeDispatched === "Invalid date" || timeDispatched === ""
        ? null
        : newTimeDispatched
  };
};

export const getTime = time => {
  if (moment(time, "HH:ss", true).isValid()) {
    return time;
  } else if (time === undefined || time === null) {
    return "";
  } else {
    return moment(time).format("HH:mm");
  }
};

export const getDate = (date: string) => moment(date).format("YYYY-MM-DD");

export const dateTimeValidation = (orderCreated, initialForm) => {
  const {
    dateDispatched,
    timeDispatched,
    dateDelivered,
    timeDelivered
  } = initialForm;

  const tempDateDispatched = moment(dateDispatched).format("YYYY-MM-DD");
  const tempDateDelivered = moment(dateDelivered).format("YYYY-MM-DD");

  const tempDispatchTime = moment(`2020-01-01 ${timeDispatched}`).format();
  const tempDeliveredTime = moment(`2020-01-01 ${timeDelivered}`).format();

  const orderCreatedDate = moment(orderCreated).format("YYYY-MM-DD");
  const orderCreatedHours = moment(orderCreated).format("HH:mm");

  const dateValidationMessage = () => {
    if (moment(tempDateDispatched).isAfter(tempDateDelivered)) {
      return "*Date dispatch should be less than or equal to date delivered";
    }
    return null;
  };
  const timeValidationMessage = () => {
    if (
      timeDispatched !== "" &&
      timeDelivered !== "" &&
      moment(tempDateDispatched).isSame(tempDateDelivered) &&
      moment(tempDispatchTime).isSameOrAfter(tempDeliveredTime)
    ) {
      return "*Time dispatch should be less than to time delivered";
    }
    return null;
  };
  const timeCreatedValidationMessage = () => {
    const tempCreatedTime = moment(`2020-01-01 ${orderCreatedHours}`).format();
    if (
      timeDispatched !== "" &&
      moment(tempDateDispatched).isSame(orderCreatedDate) &&
      moment(tempDispatchTime).isSameOrBefore(tempCreatedTime)
    ) {
      return "Time Dispatch must be greater than to Order time created";
    }
    return null;
  };

  return {
    dateErrorMessage: dateValidationMessage(),
    timeCreatedErrorMessage: timeCreatedValidationMessage(),
    timeErrorMessage: timeValidationMessage()
  };
};

export const handleLateDeliveryReason = (
  lateDeliveryReason: {
    otherReason: string;
    value: string;
  },
  onTime: boolean
) => {
  const { otherReason, value } = lateDeliveryReason;

  if (onTime) {
    return null;
  } else {
    if (value === "OTHERS") {
      return otherReason;
    } else {
      return value;
    }
  }
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};

{
  /*
  check if grab booking delivery status is on going
  this impacts Grab cancel button visibility and grab textfield inputs disabled handling
*/
}
export const handleCancelGrabBooking = (deliveryStatus: any) => {
  if (
    deliveryStatus !== null &&
    deliveryStatus !== "GRAB_CANCELED" &&
    deliveryStatus !== "GRAB_RETURNED" &&
    deliveryStatus !== "GRAB_FAILED" &&
    deliveryStatus !== "GRAB_COMPLETED" &&
    deliveryStatus !== "GRAB_USER_CANCELED" &&
    deliveryStatus !== "PANDAGO_CANCELLED" &&
    deliveryStatus !== "PANDAGO_RETURNED_TO_VENDOR" &&
    deliveryStatus !== "PANDAGO__DELIVERED" &&
    deliveryStatus !== "PANDAGO_USER_CANCELLED"
  ) {
    return true;
  } else {
    return false;
  }
};

export const handleBookingText = (
  deliveryStatus: string,
  thirdPartyRider: string,
  isInHouse: boolean
) => {
  const thirdPartyDeliveryStatus = [
    "GRAB_CANCELED",
    "GRAB_RETURNED",
    "GRAB_FAILED",
    "GRAB_USER_CANCELED",
    "PANDAGO_CANCELLED",
    "PANDAGO_RETURNED_TO_VENDOR",
    "PANDAGO_USER_CANCELLED"
  ];
  if (
    isInHouse ||
    (thirdPartyRider !== OrderCourierEnum.GRAB_EXPRESS &&
      thirdPartyRider !== OrderCourierEnum.PANDAGO_AUTO)
  ) {
    return "SUBMIT";
  } else {
    if (
      deliveryStatus === null ||
      deliveryStatus === undefined ||
      thirdPartyDeliveryStatus.includes(deliveryStatus)
    ) {
      return thirdPartyRider === OrderCourierEnum.GRAB_EXPRESS
        ? "BOOK GRAB EXPRESS"
        : "ASSIGN RIDER";
    } else {
      return "UPDATE";
    }
  }
};
